// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"c41a7ee7","453":"f1ed5905"}[chunkId] + ".chunk.js";
};